import { useTranslate } from '@tolgee/react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function FeaturesToolTip({
  feature,
  InnerComponent,
  featureIsActive
}) {
  const { t } = useTranslate();

  const renderOverlay = () => {
    if (!featureIsActive) {
      return (
        <Tooltip>
          <div>
            <div>{t(`communication.features.NO_PERMISSION_${feature}`)}</div>
            <div className={'w-100 text-end px-1 py-1'}>
              <a
                href="/subscription-management/select/"
                className={'fw-bolder text-primary'}
              >
                {t('communication.features.upgrade_subscription')}
              </a>
            </div>
          </div>
        </Tooltip>
      );
    } else {
      // null will cause issues
      return <></>; // Return null if user has permission
    }
  };

  return (
    <>
      {!featureIsActive ? (
        <OverlayTrigger
          placement="top"
          overlay={renderOverlay()}
          delay={{ show: 0, hide: 1000 }}
        >
          <div>
            <InnerComponent />
          </div>
        </OverlayTrigger>
      ) : (
        <InnerComponent />
      )}
    </>
  );
}
